import api from "@/libs/api";
import store from "@/store";

const initState = {
  defaultPanelId: null,
  usingPanelId: null,
  eventPanels: [],
  defMetadata: {},//
  metaEvents: [],//
  metaUser: [],//
  metaSegm: [],//
  eventGroups: [],
  eventsList: [],
  chartData: null,
  cacheRequest: null,
  requestParam: JSON.parse(localStorage.getItem('event_analysis_cache')) || {},
  defaultGroupId: null,
  chartType: "line",
  timeRange: [],
  timeUnit: "day",
  tagsList: [],
  visibleMeasures: [], // 事件分析可显示的指标
  echartsMeasures: [], // 事件分析可显示的指标
  visibleGroups: [], // 事件分析可显示的分组
  chartTitle: "",
  showUserDetail: false,
  userDetailParams: {},
  bookShow: "",
  fromDash: false,
  updataChart: false,
  dictionary: {},
  paramValue: [],
  normalEvents: {}
};

console.log(JSON.parse(localStorage.getItem('event_analysis_cache')), 'gag')

function sort(ary) {
  return ary.sort((a, b) =>
    (a.cname ? a.cname : a.name).localeCompare(
      b.cname ? b.cname : b.name,
      "zh"
    )
  ); //中文排序;
}

const eventAnalysis = {
  state: initState,
  mutations: {
    SET_DICTIONARY (state, {key, val}) {
      state.dictionary[key] = val
    },
    SET_NORMALEVENTS (state, [key, val]) {
      state.normalEvents[key] = val
    },
    RESET_eventAnalysis(state) {
      state = Object.assign(state, initState);
    },
    SET_DEFAULT_PANEL_ID(state, id) {
      state.defaultPanelId = id;
    },
    SET_USING_PANEL_ID(state, id) {
      state.usingPanelId = id;
    },
    SET_EVENT_PANELS(state, panels) {
      state.eventPanels = panels;
    },
    SET_EVENT_GROUPS(state, groups) {
      state.eventGroups = groups;
    },
    SET_FROM_URL(state, url) {
      state.bookShow = url;
    },
    SET_FROM_DASH(state, dash) {
      state.fromDash = dash;
    },
    SET_CHART_DASH(state, dash) {
      state.updataChart = dash;
    },
    SET_DEFAULT_GROUP_ID(state, id) {
      state.defaultGroupId = id;
    },
    SET_META_EVENTS(state, param) {
      state.metaEvents = param;
    },
    SET_META_DATA(state, data) {
      state.defMetadata = data.fields;

      if (data.fields.event) {
        let val = sort(data.fields.event.map(event => {
          event.properties.unshift({
            // event.properties.push({
            id: 0,
            cname: "Distinct ID",
            dataType: "string",
            dbColumnName: null,
            defaultValue: null,
            dimension: false,
            eventId: 0,
            eventName: event.name,
            hasDict: false,
            measure: false,
            propertyName: "distinct_id",
            propertyType: 1,
            unit: "",
            visible: true
          });
          sort(event.properties)
          return Object.assign(event, {
            properties: Object.assign(event.properties)
          })
        }))
        const index = val.findIndex(item => item.id === 0)
        const anyEvent = val[index]
        val.splice(index, 1)
        if (anyEvent) {
          val.unshift(anyEvent)
        }
        state.metaEvents = val
        console.log(state.metaEvents, 'state.metaEventsstate.metaEvents')
      } else {
        state.metaEvents = []
      }
      state.metaUser = sort(data.fields.user);
      state.metaSegm = sort(data.fields.segm);
    },
    SET_MATE_SEG(state, data) {
      state.metaSegm = data;
    },
    SET_CHART_DATA(state, data) {
      state.chartData = data;
    },
    SET_PARAM_VALUE(state, data) {
      state.paramValue = data;
    },
    SET_CACHE_REQUEST(state, obj) {
      state.cacheRequest = obj;
    },

    SET_REQUEST_PARAM(state, obj) {
      state.requestParam = Object.assign({}, state.requestParam, obj)
      localStorage.setItem('event_analysis_cache', JSON.stringify(state.requestParam))
    },
    SET_CHART_TYPE(state, type) {
      // console.log(type, "type");
      //1
      state.chartType = type; //pie
    },
    SET_TIME_RANGE(state, range) {
      // console.log(range, "range");

      //1
      state.timeRange = range; //时间
    },
    SET_TIME_UNIT(state, unit) {
      // console.log(unit, "unit");

      //1
      state.timeUnit = unit; //day
    },
    SET_TAGS_LIST(state, list) {
      state.tagsList = list;
    },
    SET_EVENTS_LIST(state, list) {
      state.eventsList = list;
    },
    SET_VISIBLE_MEASURE(state, list) {
      state.visibleMeasures = list;
    },
    SET_ECHARTSMEASURES(state, list) {
      state.echartsMeasures = list;
    },

    SET_VISIBLE_GROUP(state, list) {
      state.visibleGroups = list;
    },
    SET_CHART_TITLE(state, title) {
      state.chartTitle = title;
    },
    SET_USER_DETAIL(state, bool) {
      state.showUserDetail = bool;
    },
    SET_USER_DETAIL_PARAMS(state, params) {
      state.userDetailParams = params;
    },
    SET_EVENTS_GROUP_LIST(state, resolve) {
      //项目初始化或者切换项目时，初始化项目事件分组列表
      const eventsArr = state.metaEvents;
      const groups = state.eventGroups;
      const defGroupId = state.defaultGroupId;
      const inclusions = [];
      if (
        eventsArr &&
        eventsArr.length !== 0 &&
        groups &&
        groups.length !== 0
      ) {
        eventsArr.forEach(metaEvent => {
          //没有分组
          const noGroups = groups.every(group => {
            return group.events.every(evt => evt.id !== metaEvent.id);
          });
          if (noGroups) {
            inclusions.push(metaEvent.id);
            groups.find(group => group.id === defGroupId).events.push({
              from: defGroupId,
              id: metaEvent.id,
              visible: true
            });
          }
        });
        const relationParams = {
          relations: [
            {
              groupId: defGroupId,
              title: groups.find(group => group.id === defGroupId).title,
              inclusionEventIds: inclusions,
              exclusionEventIds: []
            }
          ]
        };
        if (inclusions.length > 0) {
          api
            .editGroupRelation(store.state.app.projectId, relationParams)
            .then(res => {
              // console.log(res.data);
            });
        }
        state.eventsList = groups.map(group => {

          const events = group.events.reduce((prev, evt) => {
            const target = eventsArr.find(event => event.id === evt.id);
            if (target) {
              prev.push(Object.assign({}, evt, target))
            }
            return prev
          }, [])



          const data = Object.assign({}, group, {
            editGroupTitle: false,
            events: sort(events)
          });
          console.log(data, 'ddata')
          const idx = data.events.findIndex(item => item.id === 0)
          if (idx !== -1) {
            const val = data.events[idx]
            data.events.splice(idx, 1)
            data.events.unshift(val)
          }
          return data
        });
      } else {
        state.eventsList = [];
      }
      resolve && resolve();
    }
  },
  getters: {
    eventOptions (state) {
      return sort(state.metaEvents.map((item) =>
        Object.assign({}, item, { name: `event.${item.propertyName}` })
      ))
    },
    userOptions (state) {
      return sort(state.metaUser.map((item) =>
        Object.assign({}, item, { name: `user.${item.propertyName}` })
      ))
    },
    segmOptions (state) {
      return sort(state.metaSegm.map((item) =>
        Object.assign({}, item, { name: `segm.${item.name}` })
      ));
    },
    propOptions (state, getters, ...args) {
      const groupByOptions = [
        { title: "", list: [{ cname: "总体", name: "all" }] },
        { title: "事件属性", list: getters.eventOptions },
        { title: "用户属性", list: getters.userOptions },
        { title: "用户分群", list: getters.segmOptions },
      ];
      return groupByOptions
    }
  },
  actions: {
    initDefGroupsEvents({ commit, dispatch, getters, state }, projectId) {
      return new Promise(resolve => {
        api
          .getPanels(projectId) //获取画板
          .then(panelRes => {
            if (panelRes.data.status === 1) {


              let v = panelRes.data.fields.panels[0]
              if (v) {
                if (!panelRes.data.fields.panels.find(item => item.id === 0)) {
                  const min = panelRes.data.fields.panels.reduce((prev, cur) => {
                    return prev < cur.id ? prev : cur.id
                  }, v.id)

                  panelRes.data.fields.defaultPanelId = min
                }

                commit("SET_USING_PANEL_ID", v.id);

              }


              if (panelRes.data.fields.defaultPanelId !== 0) {
                const defaultPanelId = panelRes.data.fields.defaultPanelId;
                commit("SET_EVENT_PANELS", panelRes.data.fields.panels);

                commit(
                  "SET_DEFAULT_PANEL_ID",
                  panelRes.data.fields.defaultPanelId
                );

                if (state.usingPanelId) {
                  //如果设定了正在使用的画板，则不查询默认画板
                  api
                    .getEventGroups(projectId, state.usingPanelId) //获取正在使用的画板对应的分组
                    .then(groupRes => {
                      if (groupRes.data.status === 1) {
                        if (groupRes.data.fields.defaultGroupId !== 0) {
                          commit(
                            "SET_EVENT_GROUPS",
                            groupRes.data.fields.groups
                          );
                          commit(
                            "SET_DEFAULT_GROUP_ID",
                            groupRes.data.fields.defaultGroupId
                          );
                          commit("SET_EVENTS_GROUP_LIST", resolve);
                        } else {
                          //没有分组添加默认分组

                          api
                            .addGroup(projectId, defaultPanelId, {
                              title: "默认分组",
                              visible: true,
                              remark: "添加默认分组"
                            })
                            .then(res => {
                              if (res.data.status === 1) {
                                dispatch("initDefGroupsEvents", projectId);
                              }
                            });
                        }
                      }
                    });
                } else {
                  if (!defaultPanelId) return
                  api
                    .getEventGroups(projectId, defaultPanelId) //获取默认画板对应的分组
                    .then(groupRes => {
                      if (groupRes.data.status === 1) {
                        if (groupRes.data.fields.defaultGroupId !== 0) {
                          commit(
                            "SET_EVENT_GROUPS",
                            groupRes.data.fields.groups
                          );
                          commit(
                            "SET_DEFAULT_GROUP_ID",
                            groupRes.data.fields.defaultGroupId
                          );
                          commit("SET_EVENTS_GROUP_LIST", resolve);
                        } else {
                          //没有分组添加默认分组
                          api
                            .addGroup(projectId, defaultPanelId, {
                              title: "默认分组",
                              visible: true,
                              remark: "添加默认分组"
                            })
                            .then(res => {
                              if (res.data.status === 1) {
                                dispatch("initDefGroupsEvents", projectId);
                              }
                            });
                        }
                      }
                    });
                }
              } else {
                //没有画板添加默认画板
                api.addPanel(projectId, { panelName: "默认画板" }).then(res => {
                  if (res.data.status === 1) {
                    dispatch("initDefGroupsEvents", projectId);
                  }
                });
              }
            }
          });
      });
    },
    setTagList({ commit }, projectId) {
      api
        .getTags(projectId) //获取tags
        .then(res => {
          if (res.data.status === 1) {
            const list = res.data.fields.list.map(item =>
              Object.assign({}, item, { checked: false })
            );
            commit("SET_TAGS_LIST", list);
          }
        });
    },
    getReports(context, params) {
      // console.log(context, params, "仓库数据");
      let { projectId, requestParam } = params;
      return api.getReports(projectId, requestParam);
    },
    setDefaultMetaData({ commit }, projectId) {

      // 获取元数据缓存
      let metaEventsNum = store.state.eventAnalysis.metaEvents.length
      let metaUserNum = store.state.eventAnalysis.metaUser.length
      let metaSegmNum = store.state.eventAnalysis.metaSegm.length
      //  判断元数据是否存在
      if (!(metaEventsNum > 0 & metaUserNum > 0 & metaSegmNum > 0)) {
        // 元数据不存在
        api.getMetadata(projectId).then(res => {
          if (res.data.status === 1) {
            commit("SET_META_DATA", res.data);
          }
        });
      }

    }
  }
};

export default eventAnalysis;



// WEBPACK FOOTER //
// ./src/store/modules/event-analysis.js